<div  class="outside-container mt-4" style="background-color: #fff;">
    <div class=" ">
           

            <div *ngIf="!showAdd" class="containerssss">
                <div class="content-container ">
                    
                  <div class="header">
                    <p class="titles">Manage tags</p>
                    <button (click)="onClickNew()" class="new-tag-btn">
                      <span>New tag</span>
                    </button>
                  </div>
              
                  <div class="tabs">
                    <a (click)="search.tagType='CARD';searchTags()" [class.active]="search.tagType==='CARD'">Payment Card</a>
                    <!-- <a (click)="search.tagType='CHARGER';searchTags()" [class.active]="search.tagType==='CHARGER'">CHARGER</a>
                    <a (click)="search.tagType='CONNECTOR';searchTags()" [class.active]="search.tagType==='CONNECTOR'">CONNECTOR</a>
                    <a (click)="search.tagType='LOCATION';searchTags()" [class.active]="search.tagType==='LOCATION'">LOCATION</a>
                    <a (click)="search.tagType='FLEET';searchTags()" [class.active]="search.tagType==='FLEET'">FLEET</a> -->
                  </div>
              
                  <div class="search-bar">
                    <div class="search-icon">
                      🔍
                    </div>
                    <input type="text" [(ngModel)]="search.searchText" (input)="searchTags()" placeholder="Search tags" />
                  </div>
              
                  <div class="table-container">
                    <mat-paginator  class="col-md-12 mt-2 " style="background-color: transparent;" color="primary"
                    [pageSize]="10"
                    [pageSizeOptions]="[5, 10, 25, 100]"
                    [length]="totalElements"
                    (page)="nextTagPage($event)"
                    aria-label="Select page">
                    </mat-paginator>
                    <table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <!-- <th>Members</th> -->
                          <th>Last Updated</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let list of tagList">
                          <td>{{list?.tagName || ''}}</td>
                          <td>{{list?.tagType || ''}}</td>
                          <!-- <td class="clickable" (click)="onClickTagsmapping(list?.tagId,list?.tagType,list?.tagName)">
                            {{list?.tagAssignedCount}}
                          </td> -->
                          <td>
                            <span *ngIf="list?.modTs">{{SettingsService.formatDate(list?.modTs)}}</span>
                            <span *ngIf="!list?.modTs">{{SettingsService.formatDate(list?.genTs)}}</span>
                          </td>
                          <td>
                            <button (click)="onEditClick(list)">Edit</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
            
             
               
              <div *ngIf="showAdd" class="gap-1 px-2 flex flex-1 justify-start " style="text-align: start;">
                <div class="layout-content-container flex flex-col  max-w-[1400px] flex-1">
                  <div class="flex flex-wrap justify-between gap-4 ">
                    <div class="flex min-w-72 flex-col gap-3">
                      <p *ngIf="action === 'new'" class="text-title">Create a new tag</p>
                      <p *ngIf="action === 'update'" class="text-title">Edit tag</p>
                      <p class="text-description">
                        Tags are used to mark and filter events. You can create custom tags to organize your data and make it easier to understand.
                      </p>
                    </div>
                    <div class="flex min-w-72 flex-col gap-3">
                        <button (click)="close()" class="btn-cancel">Cancel</button>

                    </div>
                  </div>
                  <div class="flex flex-wrap items-end gap-4  py-3">
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Tag Type <span class="required">*</span></p>
                      <mat-select [(ngModel)]="tagsRequest.tagType" class="form-input">
                        <mat-option class="mat-primary"   value="CARD">&nbsp;&nbsp;{{'CARD'}}</mat-option>

                      </mat-select>
                    </label>
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Tag name <span class="required">*</span></p>
                      <input [(ngModel)]="tagsRequest.tagName" maxlength="30" [readonly]="action === 'update'" class="form-input" />
                    </label>
                  </div>
                  <div class="flex flex-wrap items-end gap-4  py-3">
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Description</p>
                      <textarea maxlength="200" [(ngModel)]="tagsRequest.description" placeholder="Add a description to help you remember what this tag is for." class="form-input"></textarea>
                    </label>
                  </div>
                  <h3 class="section-title">Add properties or values</h3>
                  <div class="flex flex-wrap items-end gap-4  py-3" *ngFor="let item of array">
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Property</p>
                      <input maxlength="30" [(ngModel)]="item.property" class="form-input" />
                    </label>
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Operators</p>
                      <mat-select [(ngModel)]="item.operator" class="form-input">
                        <mat-option class="mat-primary" value="=">&nbsp;=&nbsp;</mat-option>
                        <mat-option class="mat-primary" value=">">&nbsp;>&nbsp;</mat-option>
                        <mat-option class="mat-primary" value="<">&nbsp;<&nbsp;</mat-option>
                      </mat-select>
                    </label>
                    <label class="flex flex-col min-w-40 flex-1">
                      <p class="label-text">Value</p>
                      <!-- <input [(ngModel)]="item.value" maxlength="30" class="form-input" /> -->
                      <mat-select matNativeControl class="form-input" name="cardType"  [(ngModel)]="item.value" >
                        <mat-option class="mat-primary"  *ngFor="let card of cardtypedata"  [value]="card">{{card}}</mat-option>
    
                      </mat-select>  
                    </label>
                  </div>
                  <div class="flex  py-3">
                    <button (click)="Array()" class="btn-add">Add another property or value</button>
                    <button (click)="cancel()" class="btn-cancel">X</button>
                  </div>
                  <div class="">
                    <label class="flex gap-x-3 py-3 flex-row">
                      <input [(ngModel)]="tagsRequest.assignTag"  type="checkbox" class="checkbox" />
                      <p class="text-checkbox">Assign this tag to all users</p>
                    </label>
                  </div>
                  <div class="flex justify-stretch">
                    <div class="flex flex-1 gap-3 flex-wrap px-4 py-3 justify-end">
                      <button *ngIf="action === 'new' && !this.disabled()" (click)="saveCustomer()" class="btn-save">Save tag</button>
                      <button *ngIf="action === 'new' && this.disabled()" class="btn-disabled">Save tag</button>
                      <button *ngIf="action === 'update' && !this.disabled()" (click)="UpdateTag()" class="btn-save">Update tag</button>
                      <button *ngIf="action === 'update' && this.disabled()" class="btn-disabled">Update tag</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
 
 
 

    <p-sidebar [(visible)]="tagsMapping" position="left" styleClass="col-md-10" >
      <ng-template pTemplate="header">
        <strong class="col-md-11 font-semibold text-xl">{{tagMapping?.tagName}} {{tagMapping?.tagType?('('+tagMapping?.tagType+')'):''}}  </strong>
          
        <!-- pTemplate="headless" -->
      
    </ng-template>
    <span  >
      <app-tags-mapping *ngIf="tagsMapping"></app-tags-mapping>
   
    <br>
    </span>
    <!-- <ng-template pTemplate="footer">
      <div class=" d-flex justify-content-end">
  <button mat-flat-button style="color: white;background-color: #1876D0;" (click)="closeMapping()" >Close</button>
    </div>
   </ng-template> -->
  </p-sidebar>
